import {BaseMobxStore} from "../../../../infrastructure/mobx/base-mobx-store";
import {BettingPromotionModuleConfig} from "./betting-promotion.module.config";
import {BettingPromotionModuleState} from "./models/betting-promotion.module.state";

export class BettingPromotionModuleStore extends BaseMobxStore {
  static injectables = [BettingPromotionModuleConfig, BettingPromotionModuleState];
}
